<app-header #header slot="header"></app-header>
<div class="footer-padding">
  <router-outlet></router-outlet>
</div>
<app-footer #footer slot="footer"></app-footer>
